document.addEventListener("DOMContentLoaded", () => {
  const searchModal = document.querySelector("[data-search-modal]");
  if (!searchModal) return;

  const searchOpenButtons = document.querySelectorAll("[data-search-open]");
  const searchCloseButtons = document.querySelectorAll("[data-search-modal-close]");
  const searchInput = searchModal.querySelector(".search-modal__input");

  // ---------------------------------------------------------------------
  // Visual Viewport sync — keep the form centred in the actually-visible
  // region of the screen when the mobile keyboard is open.
  //
  // iOS Safari: the keyboard OVERLAYS the viewport, so `innerHeight` and
  //   CSS 100vh stay at full-screen — flex centering drops the form right
  //   next to the keyboard.
  // Android Chrome: the keyboard RESIZES the viewport, so it mostly works
  //   correctly, but this handler covers both cases uniformly.
  //
  // We write the visible height + top offset into CSS custom properties
  // on the modal, and the SCSS uses them to absolutely position the form
  // in the visible-region centre.
  // ---------------------------------------------------------------------

  const syncViewportVars = () => {
    const vv = window.visualViewport;
    if (!vv) {
      // Fallback for browsers without VisualViewport API — use inner size.
      searchModal.style.setProperty("--sm-vv-height", `${window.innerHeight}px`);
      searchModal.style.setProperty("--sm-vv-offset-top", "0px");
      return;
    }
    searchModal.style.setProperty("--sm-vv-height", `${vv.height}px`);
    searchModal.style.setProperty("--sm-vv-offset-top", `${vv.offsetTop}px`);
  };

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", syncViewportVars);
    window.visualViewport.addEventListener("scroll", syncViewportVars);
  }
  window.addEventListener("resize", syncViewportVars);

  const openSearchModal = () => {
    searchModal.setAttribute("data-search-modal-open", "");
    searchModal.setAttribute("aria-hidden", "false");
    document.body.classList.add("overflow-hidden");
    syncViewportVars(); // initial sync before focus triggers keyboard
    if (searchInput) {
      searchInput.focus();
    }
  };

  const closeSearchModal = () => {
    searchModal.removeAttribute("data-search-modal-open");
    searchModal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("overflow-hidden");
  };

  searchOpenButtons.forEach((btn) => {
    btn.addEventListener("click", openSearchModal);
  });

  searchCloseButtons.forEach((btn) => {
    btn.addEventListener("click", closeSearchModal);
  });

  // Close on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && searchModal.hasAttribute("data-search-modal-open")) {
      closeSearchModal();
    }
  });
});
